import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserRecord, USER_ROLES, roleInfo, DataService } from '@core/services/data.service';
import { ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './user-editor.component.html',
  styleUrls: ['./user-editor.component.scss']
})
export class UserEditorComponent implements OnInit {

  @Input()
  public user: UserRecord;

  @Output()
  public change = new EventEmitter<UserRecord>();

  public roles = USER_ROLES;

  public info = roleInfo;

  constructor(private ds: DataService, private modal: ModalService) { }

  ngOnInit(): void {
    this.user = this.user ? { ...this.user, Roles: [...this.user.Roles] } : { ID: 0, Username: '', Password: '', Roles: [] }
  }

  public is(role: string) {
    return this.user.Roles.contains(role);
  }

  public toggle(role: string) {
    if (this.user.Roles.contains(role)) {
      this.user.Roles = this.user.Roles.filter(i => i != role);
    }
    else {
      this.user.Roles.push(role);
    }
  }

  public close() {
    this.modal.of(this).hide();
  }

  public save() {
    this.ds.users(this.user.ID > 0 ? 'update' : 'create', this.user).subscribe(users => {
      if (users && users.length == 1) {
        this.user = users[0];
        this.change.emit(this.user);
        this.modal.of(this).hide();
      }
    });
  }
}
